<div class="layout-container">
  <!-- Sidebar -->
  <app-sidebar
    [visible]="sidebarVisible"
    [isMobile]="isMobile"
    [isCollapsed]="sidebarCollapsed"
    (visibleChange)="sidebarVisible = $event"
    (collapsedChange)="onSidebarCollapsedChange($event)"
  ></app-sidebar>

  <!-- Main Content -->
  <div class="layout-content"
       [class.sidebar-open]="sidebarVisible && !isMobile && !sidebarCollapsed"
       [class.sidebar-collapsed]="sidebarVisible && !isMobile && sidebarCollapsed">
    <div class="content-wrapper">
      <app-navbar
        (toggleSidebarEvent)="toggleSidebar()"
        [isMobile]="isMobile"
      ></app-navbar>

      <div class="layout-main-container">
        <div class="layout-main px-4 py-4 md:px-6 lg:px-8">
          <router-outlet></router-outlet>
          <ng-container #modalContainer></ng-container>
          <app-block-document-ui></app-block-document-ui>
        </div>
        <app-footer></app-footer>
      </div>
    </div>

  </div>
</div>
